import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuTitle,
} from 'shared/components/ui/popup-menu';
import { TaskPriorityOptions } from 'shared/types/task-base';

export type PriorityPickerMenuProps = Omit<
  React.ComponentProps<typeof PopupMenu>,
  'children' | 'onOutside'
> & {
  value?: TaskPriorityOptions | null;
  onClose: () => void;
  onChange: (value: TaskPriorityOptions | null) => void;
};

export const PriorityPickerMenu: React.FC<PriorityPickerMenuProps> = ({
  value,
  onChange,
  onClose,
  ...rest
}) => {
  const { t } = useTranslation();

  const onClear = () => {
    onChange(null);
    onClose();
  };

  const onHigh = () => {
    onChange(TaskPriorityOptions.High);
    onClose();
  };

  const onMedium = () => {
    onChange(TaskPriorityOptions.Medium);
    onClose();
  };

  const onLow = () => {
    onChange(TaskPriorityOptions.Low);
    onClose();
  };

  return (
    <PopupMenu onOutside={onClose} {...rest}>
      <PopupMenuList>
        <PopupMenuTitle title={t('task.priority.options.title')} />
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onClear}
            start={!value ? <Icon icon={Check} /> : undefined}
            indentationLevel={!!value ? 1 : 0}
          >
            {t('task.priority.options.none.label')}
          </PopupMenuButton>
        </PopupMenuListItem>
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onLow}
            start={
              value === TaskPriorityOptions.Low ? (
                <Icon icon={Check} />
              ) : undefined
            }
            indentationLevel={value !== TaskPriorityOptions.Low ? 1 : 0}
          >
            {t('task.priority.options.low.label')}
          </PopupMenuButton>
        </PopupMenuListItem>
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onMedium}
            start={
              value === TaskPriorityOptions.Medium ? (
                <Icon icon={Check} />
              ) : undefined
            }
            indentationLevel={value !== TaskPriorityOptions.Medium ? 1 : 0}
          >
            {t('task.priority.options.medium.label')}
          </PopupMenuButton>
        </PopupMenuListItem>
        <PopupMenuListItem>
          <PopupMenuButton
            onClick={onHigh}
            start={
              value === TaskPriorityOptions.High ? (
                <Icon icon={Check} />
              ) : undefined
            }
            indentationLevel={value !== TaskPriorityOptions.High ? 1 : 0}
          >
            {t('task.priority.options.high.label')}
          </PopupMenuButton>
        </PopupMenuListItem>
      </PopupMenuList>
    </PopupMenu>
  );
};
